import './style.scss';

export function gear_sale_enquiry_form_block() {
    const block = document.querySelector('.gear_sale_enquiry_form_block');
    if (!block) return;

}
